import { Button } from "@jutro/ui";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { ErrorMessage } from "components/TagFormNew/ErrorMessage";
import { TagForm } from "components/TagFormNew/types";
import { MedicalDocumentationList } from "components/new/MedicalDocumentation/List";
import {
  DoctorMSMedicalRecordEntity,
  useDoctorGetDocumentsQuery,
} from "lib/graphql/megaSchema";
import { TileColumn } from "lib/tools/createWorkspace/types";
import { useTileSystem } from "lib/tools/createWorkspace/useTileSystem";
import { chosenMedicalRecordsAtom, hasDocumentErrorAtom } from "../atoms";

type Props = {
  patientId: string;
  tagForm: TagForm;
};

export const DocumentationSection = ({ patientId, tagForm }: Props) => {
  const [chosenDocuments, setChosenDocuments] = useAtom(
    chosenMedicalRecordsAtom,
  );
  const [hasDocumentError, setHasDocumentError] = useAtom(hasDocumentErrorAtom);
  const { addTile } = useTileSystem();
  const { tag: editedTag, type } = tagForm;

  const { data } = useDoctorGetDocumentsQuery({
    variables: { id: patientId },
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (!data?.doctorPatient || type === "create") return;

    setChosenDocuments(
      data.doctorPatient.documents.filter(
        (doc) => doc.tagId && doc.tagId === editedTag?.id,
      ) as DoctorMSMedicalRecordEntity[],
    );
  }, [data, editedTag, type]);

  useEffect(() => {
    return () => {
      setChosenDocuments([]);
    };
  }, []);

  useEffect(() => {
    setHasDocumentError(false);
  }, [chosenDocuments]);

  return (
    <div className="flex flex-col gap-2">
      <MedicalDocumentationList
        documents={chosenDocuments}
        patientId={patientId}
        isDisplayOnly
      />

      <Button
        variant="secondary"
        type="button"
        text={
          chosenDocuments.length > 0
            ? "Edytuj dodane pliki"
            : "Dodaj pliki z dokumentacji"
        }
        onClick={() => {
          addTile(
            {
              id: "medical-record-file-select",
              name: "medical-record-file-select",
              data: { chosenFiles: chosenDocuments },
            },
            TileColumn.Right,
          );
        }}
      />

      {hasDocumentError && <ErrorMessage text="Dodaj plik, lub zmień źródło" />}
    </div>
  );
};
